export class messageVisibility {
    isErrorFirts: boolean  = false;
    isErrorSecond: boolean  = false;
    isSuccessFirst: boolean = false;
    isSuccessSecond: boolean  = false;
     constructor(init?: Partial<messageVisibility>) {
        Object.assign(this, init);
    }
}